import SplitHero from './splitHero';

export default SplitHero;
